import { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  NumberInput,
  NumberInputField,
  Button,
} from "@chakra-ui/react";
import { useCriarItemTabela, useAtualizarItemTabela } from "../hooks/useTabelaProcedimento";

const ItemTabelaModal = ({ isOpen, onClose, tabelaId, item }) => {
  const criarItem = useCriarItemTabela(tabelaId);
  const atualizarItem = useAtualizarItemTabela(tabelaId);

  const [codigo, setCodigo] = useState("");
  const [titulo, setTitulo] = useState("");
  const [valor, setValor] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setCodigo(item?.codigo || "");
      setTitulo(item?.titulo || "");
      setValor(item?.valor ?? 0);
    }
  }, [isOpen, item]);

  const isSaving = criarItem.isPending || atualizarItem.isPending;

  const handleSalvar = () => {
    const data = { codigo, titulo, valor: Number(valor) || 0 };
    if (item?._id) {
      atualizarItem.mutate({ itemId: item._id, data }, { onSuccess: onClose });
    } else {
      criarItem.mutate(data, { onSuccess: onClose });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{item ? "Editar procedimento" : "Novo procedimento"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4} isRequired>
            <FormLabel>Código</FormLabel>
            <Input value={codigo} onChange={(e) => setCodigo(e.target.value)} />
          </FormControl>
          <FormControl mb={4} isRequired>
            <FormLabel>Título</FormLabel>
            <Input value={titulo} onChange={(e) => setTitulo(e.target.value)} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Valor</FormLabel>
            <NumberInput value={valor} onChange={(v) => setValor(v)} min={0} precision={2}>
              <NumberInputField />
            </NumberInput>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleSalvar} isLoading={isSaving}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ItemTabelaModal;
